import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortenMetaDescriptionView = ({
  auditResult,
  editorApi
}) => {
  const {
    track
  } = useTracker();
  const {
    status,
    maxLength,
    length
  } = auditResult;
  const handleTrackAction = () => {
    track('clickedFixLink', {
      recommendationType: SeoRecommendations.SHORTEN_META_DESCRIPTION
    });
  };
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "shorten-meta-description-rec",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.SHORTEN_META_DESCRIPTION"
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.SHORTEN_META_DESCRIPTION",
      options: {
        maxLength,
        length
      }
    }),
    status: status,
    action: editorApi.shortenMetaDescription,
    actionButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.actions.SHORTEN_META_DESCRIPTION"
    }),
    onTrackAction: handleTrackAction
  });
};